import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../../guards/role.guard';
import { CaseContactsComponent } from './contacts/case-contacts/case-contacts.component';
import { CaseDetailsComponent } from './case-details/case-details.component';
import { CaseDetailsEditComponent } from './case-details-edit/case-details-edit.component';
import { Role } from '../../models/role.model';
import { PrerequisitesGuard } from '../../guards/prerequisites.guard';
import { DownloadBriefcaseComponent } from './download-briefcase/download-briefcase.component';
import { EditBriefcaseComponent } from './download-briefcase/edit-briefcase/edit-briefcase.component';
import { UploadsComponent } from './uploads/uploads.component';
import { EditUploadComponent } from './uploads/edit-upload/edit-upload.component';
import { NativeUploadBatchReportComponent } from './uploads/native-upload-batch-report/native-upload-batch-report.component';
import { ProductionUploadBatchReportComponent } from './uploads/production-upload-batch-report/production-upload-batch-report.component';
import { AppContainerComponent } from "../layout/app-container/app-container.component";
import { DatMetadataMappingComponent } from './uploads/dat-metadata-mapping/dat-metadata-mapping.component';

const caseRoutes: Routes = [
	{ path: 'CaseContacts', redirectTo: 'case/contacts', pathMatch: 'full' },
	{ path: 'case-contacts', redirectTo: 'case/contacts', pathMatch: 'full' },
	{ path: 'CaseDetails', redirectTo: 'case/details', pathMatch: 'full' },
	{ path: 'case-details', redirectTo: 'case/details', pathMatch: 'full' },
	{ path: 'CaseDetails/:id', redirectTo: 'case/details/:id', pathMatch: 'full' },
	{ path: 'case-details/:id', redirectTo: 'case/details/:id', pathMatch: 'full' },
	{ path: 'CaseDetailsEdit/:id', redirectTo: 'case/details-edit/:id', pathMatch: 'full' },
	{ path: 'case-details-edit/:id', redirectTo: 'case/details-edit/:id', pathMatch: 'full' },
	{
		path: 'case',
		component: AppContainerComponent,
		children: [
			{
				path: 'dat-metadata-mapping/:id',
				component: DatMetadataMappingComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'native-upload-validation-report/:id',
				component: NativeUploadBatchReportComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'production-upload-validation-report/:id',
				component: ProductionUploadBatchReportComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'contacts',
				component: CaseContactsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'details',
				component: CaseDetailsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations] }
			},
			{
				path: 'details/:id',
				component: CaseDetailsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Operations] }
			},
			{
				path: 'details-edit/:id',
				component: CaseDetailsEditComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.AccountFeatureSet, Role.Operations] }
			},
			{
				path: 'download-briefcase',
				component: DownloadBriefcaseComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.StandardFeatureSet] }
			},
			{
				path: 'edit-briefcase/:id',
				component: EditBriefcaseComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.Administrator, Role.StandardFeatureSet] }
			},
			{
				path: 'uploads',
				component: UploadsComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			},
			{
				path: 'uploads/:id',
				component: EditUploadComponent,
				canActivate: [PrerequisitesGuard, RoleGuard],
				data: { roles: [Role.StandardFeatureSet, Role.Administrator] }
			}
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(caseRoutes)
	],
	exports: [
		RouterModule
	]
})
export class CaseRoutingModule {
}
